import {H3Text, H6Text} from '@buncha/components/core/text';
import React, {Fragment, memo} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {B2BUserScreens} from '@buncha/B2B/navigation/types';
import {Modules} from '@buncha/utils/types';
import {StyleSheet} from 'react-native';
import {useGetLocale} from '@buncha/localization/hooks';

interface Props {
  orderId: string;
  runDetailString: string;
}

const RescheduleRunDetails = (props: Props) => {
  const muli = useFontTheme('muli');
  const mortise = useFontTheme('mortise');
  const theme = useColorThemeType();
  const {orderId, runDetailString} = props;
  const {title, body} =
    useGetLocale(Modules.B2BUserOrder, B2BUserScreens.Reschedule) ?? {};

  return (
    <Fragment>
      <H6Text style={[styles.orderId, {fontFamily: muli[400].normal}]}>
        {body?.orderId?.replace('{orderId}', orderId)}
      </H6Text>
      <H6Text
        style={[
          styles.run,
          styles.leftAlign,
          {
            fontFamily: muli[400].normal,
            color: theme?.text.blue[300],
          },
        ]}>
        {body?.currentDelivery}
        <H6Text
          style={[
            styles.leftAlign,
            {
              fontFamily: muli[700].normal,
              color: theme?.text.blue[300],
            },
          ]}>
          {runDetailString}
        </H6Text>
      </H6Text>
      <H3Text
        style={[
          styles.header,
          {
            fontFamily: mortise[700].normal,
            color: theme?.text.blue[300],
          },
        ]}>
        {title?.rescheduleDelivery}
      </H3Text>
    </Fragment>
  );
};

export default memo(RescheduleRunDetails);

const styles = StyleSheet.create({
  orderId: {textAlign: 'left', marginTop: 20},
  header: {
    textAlign: 'left',
    marginTop: 18,
  },
  run: {
    marginTop: 5,
  },
  leftAlign: {textAlign: 'left'},
});
